export default __webpack_public_path__ + "static/media/ide.4b80dc52.svg";